import { useLayoutEffect, useRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

type AutoGrowTextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  value: string;
};

function fitHeightToContent(textarea: HTMLTextAreaElement) {
  textarea.style.height = 'auto';
  textarea.style.height = String(textarea.scrollHeight) + 'px';
}

export function AutoGrowTextarea({
  value,
  className,
  rows = 1,
  ...textareaProps
}: AutoGrowTextareaProps) {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useLayoutEffect(
    function growWithContent() {
      const textarea = textareaRef.current;
      if (textarea !== null) {
        fitHeightToContent(textarea);
      }
    },
    [value]
  );

  return (
    <textarea
      ref={textareaRef}
      value={value}
      rows={rows}
      className={cn('resize-none overflow-hidden', className)}
      {...textareaProps}
    />
  );
}
